import React, { Component } from 'react';
import PlacesAutoComplete from 'react-places-autocomplete'
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';

class GooglePlacesAutoComplete extends Component {
  render() {
    return (
      <PlacesAutoComplete
          value={this.props.value}
          onChange={this.props.handleCityChange}
          onSelect={this.props.handleCitySelect}
          >
          {({ getInputProps, suggestions, getSuggestionItemProps }) => (
          <div>
            <TextField
              {...getInputProps({
                placeholder: 'City',
                className: 'location-search-input'
              })}
              name="city"
              label="City"
            />
            <div className="autocomplete-dropdown-container">
              {suggestions.map(suggestion => {
                const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                // inline style for demonstration purpose
                const style = suggestion.active
                            ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                            : { backgroundColor: '#ffffff', cursor: 'pointer' };
                return (
                  <div {...getSuggestionItemProps(suggestion, { className, style })}>
                    <span>{suggestion.description}</span>
                  </div>
                )
              })}
            </div>
          </div>
        )}
        </PlacesAutoComplete>
      )
  }
}

export default GooglePlacesAutoComplete


// WEBPACK FOOTER //
// ./src/views/GooglePlacesAutoComplete.jsx